export enum SHORT_LINK_GROUP_BY {
  DATE = 'date',
  REFERRER = 'referrer',
  COUNTRY = 'country',
  OS = 'os',
  LANGUAGE = 'language',
  LINK = 'link',
  SUBCAMPAIGN = 'subcampaign',
  CAMPAIGN = 'campaign',
}
